const STORAGE_KEY = 'relait.2fa.login'

export interface LoginChallenge {
  challenge_id: string
  email: string
  email_hint?: string
  expires_at: number
}

export const saveLoginChallenge = (challenge: LoginChallenge) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(challenge))
  } catch {
    // private mode / storage disabled — the step still works, it just cannot resume
  }
}

export const loadLoginChallenge = (): LoginChallenge | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as LoginChallenge
    if (!parsed?.challenge_id || !parsed?.email) return null
    if (!parsed.expires_at || parsed.expires_at <= Date.now()) {
      clearLoginChallenge()
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export const clearLoginChallenge = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
